export default {
    computed: {
        isMobile() {
            return this.$store.state.windowWidth <= 992 ? true : false;
        },
        noImageAvailable() {
            return "/images/icons/no-image-available.png";
        },
    },
    methods: {
        absoluteUrl(path = "") {
            if (!path) return this.$store.state.domain;

            const isAbsolute = /^(https?:\/\/)/i.test(path);
            return isAbsolute ? path : `${this.$store.state.domain}${path}`;
        },
        absoluteApiUrl(path) {
            return this.absoluteUrl(`/api${path || ""}`);
        },
        isImageFile(ext) {
            return ["png", "jpeg", "svg", "jpg", "webp"].includes(
                ext ? ext.toLowerCase() : null
            );
        },
        showProfileImg(image) {
            if (!image) {
                image = this.noImageAvailable;
            }
            let filePath = this.absoluteUrl(image);
            if (image.startsWith("http://") || image.startsWith("https://")) {
                filePath = image;
            }
            const data = { index: 0, visible: true, files: [filePath] };
            this.$store.commit("TOGGLE_LIGHT_BOX", data);
        },
        preText(content) {
            if (!content) return;
            const words = content.replace(/\n/g, " <br>").split(" ");
            const formattedWords = [];
            words.forEach((word) => {
                if (
                    word.startsWith("http://") ||
                    word.startsWith("https://") ||
                    word.startsWith("www.")
                ) {
                    formattedWords.push(
                        `<a href="${word}" class="text-primary" target="_blank"> ${word} </a>`
                    );
                } else {
                    formattedWords.push(word);
                }
            });
            return formattedWords.join(" ");
        },
        statusBadge(status) {
            if (!status) return;
            const statusCode =
                this.$store.state.appConfigData.statusColors.find(
                    (item) => item.status === status.toLowerCase()
                );
            if (!statusCode) return status;
            return `<span style="background:${statusCode.color}24; color:${statusCode.color}; padding:0px 5px 2px 5px;line-height:1; border-radius:4px;">${statusCode.title}</span>`;
        },
        scrollToView(elID) {
            if (!elID) {
                return;
            }
            const yOffset = -200;
            const element = document.getElementById(elID);
            const y =
                element.getBoundingClientRect().top +
                window.pageYOffset +
                yOffset;
            window.scrollTo({ top: y, behavior: "smooth" });
        },
        removeLeftOverBackDrop() {
            document
                .querySelectorAll(".modal-backdrop.show")
                .forEach(function (backdrop) {
                    backdrop.remove();
                });
            document.body.classList.remove("modal-open");
            document.body.style.overflow = "";
        },
        alertSuccess(text) {
            this.$store.dispatch("alertSuccess", text);
        },
        alertError(text) {
            this.$store.dispatch("alertError", text);
        },
        jsonToCSV(jsonData, delimiter = ",") {
            const headers = Object.keys(jsonData[0]);
            const csvRows = jsonData.map((row) => {
                return headers
                    .map((field) => {
                        const value = row[field] ? row[field] : "";
                        return JSON.stringify(value);
                    })
                    .join(delimiter);
            });
            return [headers.join(delimiter), ...csvRows].join("\n");
        },
        downloadCSV(csvString, filename = "data.csv") {
            // Create a blob of the CSV string
            const blob = new Blob([csvString], { type: "text/csv" });
            // Create a temporary link to trigger the download
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = filename;

            // Append the link, click it, and then remove it
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        confirmDelete(option) {
            return new Promise((resolve, reject) => {
                Swal.fire(
                    Object.assign(
                        {
                            title: "Are you sure?",
                            reverseButtons: true,
                            showCancelButton: true,
                            confirmButtonColor: "#f1556c",
                            cancelButtonColor: "#111",
                            confirmButtonText: "Delete it!",
                        },
                        option
                    )
                )
                    .then((result) => {
                        resolve(result);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        confirmAction(option) {
            return new Promise((resolve, reject) => {
                Swal.fire(
                    Object.assign(
                        {
                            title: "Confirm action!",
                            reverseButtons: true,
                            showCancelButton: true,
                            confirmButtonColor: "#225862",
                            cancelButtonColor: "#111",
                            confirmButtonText: "Yes, Proceed!",
                        },
                        option
                    )
                )
                    .then((result) => {
                        resolve(result);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        exelFileExport(payload) {
            return new Promise((resolve, reject) => {
                this.$http
                    .get(
                        `${payload.url}?${new URLSearchParams(
                            payload.data
                        ).toString()}`,
                        { responseType: "blob" }
                    )
                    .then((response) => {
                        if (response.status == 200) {
                            resolve(response);
                            const timestamp = new Date().getTime();
                            const filename =
                                (payload.filename || "") + timestamp + ".xlsx";

                            const blob = new Blob([response.data], {
                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            });
                            const link = document.createElement("a");
                            link.href = URL.createObjectURL(blob);
                            link.download = filename;
                            link.click();
                        } else {
                            throw new Error(
                                "Unexpected status code: " + response.status
                            );
                        }
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        pdfFileExport(payload) {
            return new Promise((resolve, reject) => {
                this.$http
                    .get(
                        `${payload.url}?${new URLSearchParams(
                            payload.data
                        ).toString()}`
                    )
                    .then((response) => {
                        if (response.data.success) {
                            resolve(response);
                            let filePath = this.absoluteUrl(
                                response.data.data.link
                            );
                            this.$store.commit("TOGGLE_PDF_MODAL_FRAME", {
                                visible: true,
                                filePath: filePath,
                            });
                        } else {
                            reject(response.data?.message);
                        }
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        readFileToBlob(payload) {
            return new Promise((resolve, reject) => {
                this.$http
                    .get(
                        `${this.absoluteUrl(
                            "/api/files"
                        )}?${new URLSearchParams(payload).toString()}`,
                        {
                            responseType: "blob",
                        }
                    )
                    .then((response) => {
                        if (response.status == 200) {
                            const file = new File(
                                [response.data],
                                payload.filename ||
                                    `file of ${response.data.type}`,
                                { type: response.headers["content-type"] }
                            );
                            resolve(file);
                        } else {
                            throw new Error(
                                "Unexpected status code: " + response.status
                            );
                        }
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
};
